import { createContext, useContext } from 'react';

/** What a screen registers for the shell's sub-nav (the page tree on the Pages screen). */
export interface SubNavRegistration {
    /** Phone toggle text ("Pages"). */
    label: string;
    /** Phone toggle note ("142 pages"). */
    meta?: string;
}

export interface ShellSlots {
    /** Where the registered sub-nav renders now: the desktop column, the phone drawer (open), or nowhere (drawer closed). */
    target: HTMLElement | null;
    placement: 'column' | 'drawer';
    register: (entry: SubNavRegistration | null) => void;
    /** Closes the phone drawer (after a page was chosen). */
    close: () => void;
}

export const ShellSlotsContext = createContext<ShellSlots | null>(null);

/**
 * Where the current screen's `ShellSubNav` content goes: `column` (≥ 768 px: the 240 px column next to the rail),
 * `drawer` (phones: a drawer opened from the "Pages" button under the top bar) or `inline` (no shell: tests, embeds).
 */
export function useShellSubNav(): { placement: 'column' | 'drawer' | 'inline'; close: () => void } {
    const slots = useContext(ShellSlotsContext);
    return { placement: slots ? slots.placement : 'inline', close: slots ? slots.close : () => {} };
}
